if (!customElements.get("az-sharing")) {
  customElements.define(
    "az-sharing",
    class MSharing extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          shareContent: ".az-product-addon--sharing",
          openBtn: "[data-open-share]",
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        const { shareContent } = this.domNodes;
        if (shareContent && shareContent.innerHTML) {
          this.shareContent = shareContent.innerHTML;
          this.init();
        }
      }

      init() {
        this.domNodes.openBtn && this.domNodes.openBtn.classList.remove("az:hidden");
        this.modal = new AzTheme.Modal();
        addEventDelegate({
          selector: this.selectors.openBtn,
          handler: (e) => {
            e.preventDefault();
            if (this.shareContent) {
              const html = document.createElement("DIV");
              html.classList.add('az-sharing__content');
              html.innerHTML = this.shareContent;
              this.modal.appendChild(html);
              const colorScheme = html.querySelector('[data-color-scheme]') && html.querySelector('[data-color-scheme]').dataset.colorScheme;
              this.modal.setSizes(`az-sharing az-gradient ${colorScheme}`);
              this.modal.open();
            }
          },
        });
      }
    }
  );
}
